import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _excluded = ["verify", "servcode"],
    _excluded2 = ["verify", "servcode"],
    _excluded3 = ["verify", "servcode"];

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _class2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Flow, Exception } from '../libs';
import { Injectable, Inject, Required } from '../decorators';
import { UNI_GET_METHOD_LIST, UNI_SEND_SMS, UNI_VERIFY_SMS, UNI_SEND_EMAIL_CODE, UNI_VERIFY_EMAIL_CODE, UNI_PASS, UNI_VERIFY_PASSWORD, ERR_CODE_METHOD_NOT_SUPPORT, ERR_CODE_MISSING_REQUIRED_ARGUMENTS, MOBILE_BIND_SEND_SMS, EMAIL_BIND_SEND_CODE } from '../constants';

/**
 * 统一认证
 * @link https://shopline.yuque.com/sczv0i/zbwfmf/rgyrgd
 */
export var UniFlow = (_dec = Inject(['servcode']), _dec2 = Required(['_stoken']), _dec3 = Inject(['servcode']), _dec4 = Required(['_stoken']), _dec5 = Injectable({
  oauthToken: 'data.oauthToken'
}), _dec6 = Required(['_stoken']), _dec7 = Required(['_stoken']), _dec8 = Inject(['servcode']), _dec9 = Required(['_stoken']), _dec10 = Required(['_stoken']), _dec11 = Injectable({
  oauthToken: 'data.oauthToken'
}), _dec12 = Required(['_stoken']), _dec13 = Inject(['servcode']), _dec14 = Required(['_stoken']), _dec15 = Injectable({
  oauthToken: 'data.oauthToken'
}), _dec16 = Required(['_stoken']), _dec17 = Inject(['oauthToken']), _dec18 = Required(['_stoken']), _dec19 = Inject(['oauthToken']), _dec20 = Required(['_stoken']), (_class = (_class2 = /*#__PURE__*/function (_Flow) {
  _inherits(UniFlow, _Flow);

  var _super = _createSuper(UniFlow);

  function UniFlow() {
    _classCallCheck(this, UniFlow);

    return _super.apply(this, arguments);
  }

  _createClass(UniFlow, [{
    key: "getMethodList",
    value:
    /** 获取验证手段列表 */
    function () {
      var _getMethodList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.request(UNI_GET_METHOD_LIST, params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMethodList(_x) {
        return _getMethodList.apply(this, arguments);
      }

      return getMethodList;
    }()
    /** 获取手机验证手段信息 */

  }, {
    key: "getSmsMethod",
    value: function () {
      var _getSmsMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var response, _response$data, methods;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getMethodList(params);

              case 2:
                response = _context2.sent;
                _response$data = response === null || response === void 0 ? void 0 : response.data, methods = _response$data.methods;
                return _context2.abrupt("return", methods.find(function (_ref) {
                  var method = _ref.method;
                  return method === 'sms_d';
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSmsMethod(_x2) {
        return _getSmsMethod.apply(this, arguments);
      }

      return getSmsMethod;
    }()
    /** 获取邮箱验证手段信息 */

  }, {
    key: "getEmailMethod",
    value: function () {
      var _getEmailMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var response, _response$data2, methods;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getMethodList(params);

              case 2:
                response = _context3.sent;
                _response$data2 = response === null || response === void 0 ? void 0 : response.data, methods = _response$data2.methods;
                return _context3.abrupt("return", methods.find(function (_ref2) {
                  var method = _ref2.method;
                  return method === 'email_code_d';
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getEmailMethod(_x3) {
        return _getEmailMethod.apply(this, arguments);
      }

      return getEmailMethod;
    }()
    /** 获取免检手段信息 */

  }, {
    key: "getPassMethod",
    value: function () {
      var _getPassMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var response, _response$data3, methods;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getMethodList(params);

              case 2:
                response = _context4.sent;
                _response$data3 = response === null || response === void 0 ? void 0 : response.data, methods = _response$data3.methods;
                return _context4.abrupt("return", methods.find(function (_ref3) {
                  var method = _ref3.method;
                  return method === 'pass';
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPassMethod(_x4) {
        return _getPassMethod.apply(this, arguments);
      }

      return getPassMethod;
    }()
    /** 下发短信验证码 */

  }, {
    key: "sendSms",
    value: function () {
      var _sendSms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        var verify, servcode, rest, method, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                verify = params.verify, servcode = params.servcode, rest = _objectWithoutProperties(params, _excluded);

                if (!(verify === true)) {
                  _context5.next = 13;
                  break;
                }

                if (servcode) {
                  _context5.next = 4;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_MISSING_REQUIRED_ARGUMENTS));

              case 4:
                _context5.next = 6;
                return this.getSmsMethod({
                  servcode: servcode
                });

              case 6:
                method = _context5.sent;

                if (method) {
                  _context5.next = 9;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_METHOD_NOT_SUPPORT));

              case 9:
                _context5.next = 11;
                return this.request(UNI_SEND_SMS, rest);

              case 11:
                response = _context5.sent;
                return _context5.abrupt("return", _objectSpread(_objectSpread({}, response), method));

              case 13:
                return _context5.abrupt("return", this.request(UNI_SEND_SMS, params));

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendSms(_x5) {
        return _sendSms.apply(this, arguments);
      }

      return sendSms;
    }()
    /** 验证 */

  }, {
    key: "verifySms",
    value: function () {
      var _verifySms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.request(UNI_VERIFY_SMS, params));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function verifySms(_x6) {
        return _verifySms.apply(this, arguments);
      }

      return verifySms;
    }()
    /** 下发邮箱验证码 */

  }, {
    key: "_sendEmailCode",
    value: function () {
      var _sendEmailCode2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.request(UNI_SEND_EMAIL_CODE, params));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _sendEmailCode(_x7) {
        return _sendEmailCode2.apply(this, arguments);
      }

      return _sendEmailCode;
    }()
    /** 下发邮箱验证码 */

  }, {
    key: "sendEmailCode",
    value: function () {
      var _sendEmailCode3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
        var verify, servcode, rest, method;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                verify = params.verify, servcode = params.servcode, rest = _objectWithoutProperties(params, _excluded2);

                if (!(verify === true)) {
                  _context8.next = 10;
                  break;
                }

                if (servcode) {
                  _context8.next = 4;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_MISSING_REQUIRED_ARGUMENTS));

              case 4:
                _context8.next = 6;
                return this.getEmailMethod({
                  servcode: servcode
                });

              case 6:
                method = _context8.sent;

                if (method) {
                  _context8.next = 9;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_METHOD_NOT_SUPPORT));

              case 9:
                return _context8.abrupt("return", this._sendEmailCode(rest));

              case 10:
                return _context8.abrupt("return", this._sendEmailCode(params));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sendEmailCode(_x8) {
        return _sendEmailCode3.apply(this, arguments);
      }

      return sendEmailCode;
    }()
    /** 验证邮箱验证码 */

  }, {
    key: "_verifyEmailCode",
    value: function () {
      var _verifyEmailCode2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.request(UNI_VERIFY_EMAIL_CODE, params));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _verifyEmailCode(_x9) {
        return _verifyEmailCode2.apply(this, arguments);
      }

      return _verifyEmailCode;
    }()
    /** 验证邮箱验证码 */

  }, {
    key: "verifyEmailCode",
    value: function () {
      var _verifyEmailCode3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
        var inputStoken;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                inputStoken = params.stoken;
                this._stoken = inputStoken || this._stoken || undefined;
                return _context10.abrupt("return", this._verifyEmailCode(params));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function verifyEmailCode(_x10) {
        return _verifyEmailCode3.apply(this, arguments);
      }

      return verifyEmailCode;
    }()
    /** 通过验证 */

  }, {
    key: "_pass",
    value: function () {
      var _pass2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this.request(UNI_PASS, params));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _pass(_x11) {
        return _pass2.apply(this, arguments);
      }

      return _pass;
    }()
    /**
     * 通过验证
     * @description
     * 账号即没绑定手机，也没绑定邮箱的，会触发该验证。
     * 目前仅有第三方登录账号绑定邮箱或手机时会触发，且没绑定手机和邮箱的账号不允许修改密码。
     */

  }, {
    key: "pass",
    value: function () {
      var _pass3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
        var verify, servcode, rest, method;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                verify = params.verify, servcode = params.servcode, rest = _objectWithoutProperties(params, _excluded3);

                if (!(verify === true)) {
                  _context12.next = 10;
                  break;
                }

                if (servcode) {
                  _context12.next = 4;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_MISSING_REQUIRED_ARGUMENTS));

              case 4:
                _context12.next = 6;
                return this.getPassMethod({
                  servcode: servcode
                });

              case 6:
                method = _context12.sent;

                if (method) {
                  _context12.next = 9;
                  break;
                }

                throw new Exception(_objectSpread({}, ERR_CODE_METHOD_NOT_SUPPORT));

              case 9:
                return _context12.abrupt("return", this._pass(rest));

              case 10:
                return _context12.abrupt("return", this._pass(params));

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function pass(_x12) {
        return _pass3.apply(this, arguments);
      }

      return pass;
    }()
    /** 密码验证 */

  }, {
    key: "verifyPassword",
    value: function () {
      var _verifyPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.request(UNI_VERIFY_PASSWORD, params));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function verifyPassword(_x13) {
        return _verifyPassword.apply(this, arguments);
      }

      return verifyPassword;
    }()
    /** 发送短信验证码 */

  }, {
    key: "sendBindSms",
    value: function () {
      var _sendBindSms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.request(MOBILE_BIND_SEND_SMS, params));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function sendBindSms(_x14) {
        return _sendBindSms.apply(this, arguments);
      }

      return sendBindSms;
    }()
    /** 发送验证码 */

  }, {
    key: "sendBindEmailCode",
    value: function () {
      var _sendBindEmailCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.request(EMAIL_BIND_SEND_CODE, params));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function sendBindEmailCode(_x15) {
        return _sendBindEmailCode.apply(this, arguments);
      }

      return sendBindEmailCode;
    }()
  }]);

  return UniFlow;
}(Flow), _defineProperty(_class2, "flowName", 'UniFlow'), _class2), (_applyDecoratedDescriptor(_class.prototype, "getMethodList", [_dec, _dec2], Object.getOwnPropertyDescriptor(_class.prototype, "getMethodList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendSms", [_dec3, _dec4], Object.getOwnPropertyDescriptor(_class.prototype, "sendSms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verifySms", [_dec5, _dec6], Object.getOwnPropertyDescriptor(_class.prototype, "verifySms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_sendEmailCode", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "_sendEmailCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendEmailCode", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class.prototype, "sendEmailCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_verifyEmailCode", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "_verifyEmailCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verifyEmailCode", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "verifyEmailCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_pass", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "_pass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pass", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class.prototype, "pass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verifyPassword", [_dec15, _dec16], Object.getOwnPropertyDescriptor(_class.prototype, "verifyPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendBindSms", [_dec17, _dec18], Object.getOwnPropertyDescriptor(_class.prototype, "sendBindSms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendBindEmailCode", [_dec19, _dec20], Object.getOwnPropertyDescriptor(_class.prototype, "sendBindEmailCode"), _class.prototype)), _class));